/**
 * @file 文章列表（无图片）
 * @author wangzhuang
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './index.less';

export default class ListPage extends Component {
    static propTypes = {
        title: PropTypes.string,
        text: PropTypes.string

    };

    render() {
        const {title, text} = this.props;
        return (
            <div className={'list-page'}>
                <div
                    className={'list-page-title'}
                    dangerouslySetInnerHTML={{__html: title}}
                >
                </div>
                <div
                    className={'list-page-text'}
                    dangerouslySetInnerHTML={{__html: text}}
                >
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ListPage/index.js